import { useMutation } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const createBlocker = (axios) => async (params) => {
  const { data } = await axios.post("/api/v2/blockers", params);
  return data;
};
const editBlocker = (axios) => async (params) => {
  const { data } = await axios.put(`/api/v2/blockers/${params.referenceId}`, params);
  return data;
};
const useSaveBlocker = (clinicReferenceId, onSuccess) => {
  const { shiftPlanner } = useAxiosProvider();
  if (!shiftPlanner) {
    throw new Error("shiftPlanner axios instance is not defined");
  }
  const mutation = useMutation({
    mutationFn: (blocker) => {
      const payload = { ...blocker, clinicReferenceId };
      if (blocker.referenceId) {
        return editBlocker(shiftPlanner)(payload);
      }
      return createBlocker(shiftPlanner)(payload);
    },
    onSuccess: () => {
      onSuccess == null ? void 0 : onSuccess();
    }
  });
  return mutation;
};
export {
  useSaveBlocker
};
